var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isScrollToTop ? _vm.visible : this.someActivitiesAreSelected),expression:"isScrollToTop ? visible : this.someActivitiesAreSelected"}],staticClass:"bottom-right fade-in-image",on:{"click":function($event){return _vm.emitContinueEvent()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }